import { apiClient } from '../../api/client';
import { endpoints } from '../../api/endpoints';
import { tokenStorage } from '../../api/tokenStorage';
import type {
  AuthResponse,
  ChangePasswordRequest,
  ForgotPasswordRequest,
  LoginRequest,
  MessageResponse,
  RegisterRequest,
  RegisterResponse,
  ResendEmailVerificationRequest,
  ResetPasswordRequest,
  UpdateProfileRequest,
} from '../../types/api';
import type { User } from '../../types';

export async function httpLogin(data: LoginRequest): Promise<AuthResponse> {
  return apiClient<AuthResponse>(endpoints.auth.login, {
    method: 'POST',
    body: data,
    auth: false,
  });
}

export async function httpRegister(data: RegisterRequest): Promise<RegisterResponse> {
  return apiClient<RegisterResponse>(endpoints.auth.register, {
    method: 'POST',
    body: data,
    auth: false,
  });
}

export async function httpVerifyEmail(token: string): Promise<MessageResponse> {
  return apiClient<MessageResponse>(endpoints.auth.verifyEmail, {
    method: 'POST',
    body: { token },
    auth: false,
  });
}

export async function httpForgotPassword(data: ForgotPasswordRequest): Promise<MessageResponse> {
  return apiClient<MessageResponse>(endpoints.auth.forgotPassword, {
    method: 'POST',
    body: data,
    auth: false,
  });
}

export async function httpResendVerificationEmail(
  data: ResendEmailVerificationRequest,
): Promise<MessageResponse> {
  return apiClient<MessageResponse>(endpoints.auth.resendVerificationEmail, {
    method: 'POST',
    body: data,
    auth: false,
  });
}

export async function httpResetPassword(data: ResetPasswordRequest): Promise<MessageResponse> {
  return apiClient<MessageResponse>(endpoints.auth.resetPassword, {
    method: 'POST',
    body: data,
    auth: false,
  });
}

export async function httpLogout(): Promise<void> {
  await apiClient<void>(endpoints.auth.logout, { method: 'POST' });
}

export async function httpGetCurrentUser(): Promise<User | null> {
  if (!tokenStorage.get()) {
    return null;
  }

  try {
    return await apiClient<User>(endpoints.auth.me);
  } catch {
    return null;
  }
}

export async function httpUpdateProfile(data: UpdateProfileRequest): Promise<User> {
  return apiClient<User>(endpoints.auth.updateProfile, {
    method: 'PATCH',
    body: data,
  });
}

export async function httpChangePassword(data: ChangePasswordRequest): Promise<MessageResponse> {
  return apiClient<MessageResponse>(endpoints.auth.changePassword, {
    method: 'POST',
    body: data,
  });
}
